import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/feed/")({
    component: FeedStructurePage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureFeed],
        showInSideMenu: false,
        label: "pages.tool.structure.feed.title",
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.tool.structure.feed.title"),
    }),
});

function FeedStructurePage() {
    return (
        <TenantPage headerNavigationItems={getToolStructureHeaderItems}>
            <></>
        </TenantPage>
    );
}
